module.exports = __webpack_public_path__ + "0926cc62cdc5fc38346069008b197fd6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/vue-cli-selections.png
// module id = 277
// module chunks = 1